import React from 'react';
import toast from 'react-hot-toast';

/** The backend answers 402 when a free-plan limit stops a create. */
export const isPlanLimitError = (err: unknown): boolean =>
  (err as { response?: { status?: number } })?.response?.status === 402;

export const showPlanLimitToast = (message: string) => {
  toast.error(
    <span>
      {message} <a href="/subscription" style={{ fontWeight: 600 }}>Upgrade</a>
    </span>,
    { id: 'plan-limit', duration: 8000 }
  );
};
